



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { without } from 'lodash';

@Component
export default class FilterMenu extends Vue {
    @Prop({ type: Array, required: true })
    items !: string[];
    @Prop({ type: Array, default: () => [] })
    value !: string[]
    @Prop()
    id ?: string;

    active : boolean = false;

    search: string = "";
    selection: Map<string, boolean> = new Map();

    @Watch('value')
    reset(value : string[]) {
        if (value.length === 0) {
            this.search = "";
        }
    }

    @Watch("items")
    refreshSelection(newItems : string[]) {
        if (this.value.length > 0) {
            this.$emit('input', this.value.filter(v => newItems.includes(v)));
        }
    }

    get filteredItems() {
        const filtered = this.items.filter(name => name.toLowerCase().includes(this.search.toLowerCase()));
        return filtered.sort(
            (i1, i2) => i1.toLowerCase() > i2.toLowerCase() ? 1 : i1.toLowerCase() < i2.toLowerCase() ? -1 : 0
        );
    }

    clearSearchOnClose(open: boolean) {
        if (!open) this.search = "";
    }

    selectItem(item : string, selected : boolean) {
        let newValue : string[];
        if (selected) {
            newValue = this.value.concat([item]);
        } else {
            newValue = without(this.value, item);
        }
        this.$emit('input', newValue);
    }
}
